import NarrativeTypeContextProvider from './state/narrativeType/NarrativeTypeContextProvider';
import IneligibleReasonContextProvider from './state/ineligibleReason/IneligibleReasonContextProvider';
import SocialMediaTypeContextProvider from './state/socialMediaType/SocialMediaTypeContextProvider';
import FunFactsTypeContextProvider from './state/funFactsType/FunFactsTypeContextProvider';
import FrequentFlyerTypeContextProvider from './state/frequentFlyerType/FrequentFlyerTypeContextProvider';
import SupportStaffTypeContextProvider from './state/supportStaffType/SupportStaffTypeContextProvider';
import TestingBodyContextProvider from './state/testingBody/TestingBodyContextProvider';
import DrugTestStatusContextProvider from './state/drugTestStatus/DrugTestStatusContextProvider';
import SponsorContextProvider from './state/sponsor/SponsorContextProvider';
import CoachTypeContextProvider from './state/coachType/CoachTypeContextProvider';
import ApparelTypeContextProvider from './state/apparelType/ApparelTypeContextProvider';
import NationalTeamGroupOfficialRosterContextProvider from './state/nationalTeamGroupOfficialRoster/NationalTeamGroupOfficialRosterContextProvider';
import ImxImrSeasonContextProvider from './state/imxImrSeason/ImxImrSeasonContextProvider';
import VccSeasonContextProvider from './state/vccSeason/VccSeasonContextProvider';

import OrganizationContextProvider from '@usas/ui-web/state/organization/OrganizationContextProvider';
import ZoneContextProvider from '@usas/ui-web/state/zone/ZoneContextProvider';
import LscContextProvider from '@usas/ui-web/state/lsc/LscContextProvider';
import MeetClassificationFlatContextProvider from '@usas/ui-web/state/meet/meetClassificationFlat/MeetClassificationFlatContextProvider';
import OrgUnitContextProvider from '@usas/ui-web/state/orgUnit/OrgUnitContextProvider';
import OrgUnitContextProviderLocal from '../app/state/orgUnit/OrgUnitContextProviderLocal';
import OrgRoleHierarchyContextProvider from '@usas/ui-web/state/orgRoleHierarchy/OrgRoleHierarchyContextProvider';
import OrgRoleContextProvider from '@usas/ui-web/state/orgRole/OrgRoleContextProvider';
import ReportPeriodFlatContextProvider from '@usas/ui-web/state/reportPeriodFlat/ReportPeriodFlatContextProvider';
import EventContextProvider from '@usas/ui-web/state/event/EventContextProvider';
import DisabilityTypeContextProvider from '@usas/ui-web/state/disabilityType/DisabilityTypeContextProvider';
import HispanicOrLatinoTypeContextProvider from '@usas/ui-web/state/hispanicOrLatinoType/HispanicOrLatinoTypeContextProvider';
import EthnicityTypeContextProvider from '@usas/ui-web/state/ethnicityType/EthnicityTypeContextProvider';
import CompetitionGenderTypeContextProvider from '@usas/ui-web/state/competitionGender/CompetitionGenderTypeContextProvider';
import OrgGroupPropertiesContextProvider from '@usas/ui-web/state/orgGroupProperties/OrgGroupPropertiesContextProvider';
import ContactRelationshipTypesContextProvider from '@usas/ui-web/state/contactRelationshipType/ContactRelationshipTypesContextProvider';
import CourseContextProvider from '@usas/ui-web/state/course/CourseContextProvider';
import TimeStandardTypeContextProvider from '@usas/ui-web/state/timeStandardType/TimeStandardTypeContextProvider';
import EventCompetitionGenderTypeContextProvider from '@usas/ui-web/state/eventCompetitionGender/EventCompetitionGenderTypeContextProvider';
import ClubOwnerTypeContextProvider from '../../../club-ui/src/app/state/clubOwnerType/ClubOwnerTypeContextProvider';

const AppStateContextProviders = ({ children }) => {
  return (
    <OrganizationContextProvider>
      <ZoneContextProvider>
        <ClubOwnerTypeContextProvider>
          <NationalTeamGroupOfficialRosterContextProvider>
            <LscContextProvider>
              <ImxImrSeasonContextProvider>
                <VccSeasonContextProvider>
                  <MeetClassificationFlatContextProvider>
                    <OrgUnitContextProvider>
                      <OrgUnitContextProviderLocal>
                        <OrgRoleHierarchyContextProvider>
                          <OrgRoleContextProvider>
                            <ReportPeriodFlatContextProvider>
                              <CourseContextProvider>
                                <EventContextProvider>
                                  <TimeStandardTypeContextProvider>
                                    <EventCompetitionGenderTypeContextProvider>
                                      <ContactRelationshipTypesContextProvider>
                                        <DisabilityTypeContextProvider>
                                          <HispanicOrLatinoTypeContextProvider>
                                            <EthnicityTypeContextProvider>
                                              <NarrativeTypeContextProvider>
                                                <IneligibleReasonContextProvider>
                                                  <SocialMediaTypeContextProvider>
                                                    <FunFactsTypeContextProvider>
                                                      <FrequentFlyerTypeContextProvider>
                                                        <ApparelTypeContextProvider>
                                                          <SupportStaffTypeContextProvider>
                                                            <TestingBodyContextProvider>
                                                              <DrugTestStatusContextProvider>
                                                                <SponsorContextProvider>
                                                                  <CoachTypeContextProvider>
                                                                    <CompetitionGenderTypeContextProvider>
                                                                      <OrgGroupPropertiesContextProvider>
                                                                        {children}
                                                                      </OrgGroupPropertiesContextProvider>
                                                                    </CompetitionGenderTypeContextProvider>
                                                                  </CoachTypeContextProvider>
                                                                </SponsorContextProvider>
                                                              </DrugTestStatusContextProvider>
                                                            </TestingBodyContextProvider>
                                                          </SupportStaffTypeContextProvider>
                                                        </ApparelTypeContextProvider>
                                                      </FrequentFlyerTypeContextProvider>
                                                    </FunFactsTypeContextProvider>
                                                  </SocialMediaTypeContextProvider>
                                                </IneligibleReasonContextProvider>
                                              </NarrativeTypeContextProvider>
                                            </EthnicityTypeContextProvider>
                                          </HispanicOrLatinoTypeContextProvider>
                                        </DisabilityTypeContextProvider>
                                      </ContactRelationshipTypesContextProvider>
                                    </EventCompetitionGenderTypeContextProvider>
                                  </TimeStandardTypeContextProvider>
                                </EventContextProvider>
                              </CourseContextProvider>
                            </ReportPeriodFlatContextProvider>
                          </OrgRoleContextProvider>
                        </OrgRoleHierarchyContextProvider>
                      </OrgUnitContextProviderLocal>
                    </OrgUnitContextProvider>
                  </MeetClassificationFlatContextProvider>
                </VccSeasonContextProvider>
              </ImxImrSeasonContextProvider>
            </LscContextProvider>
          </NationalTeamGroupOfficialRosterContextProvider>
        </ClubOwnerTypeContextProvider>
      </ZoneContextProvider>
    </OrganizationContextProvider>
  );
};

export default AppStateContextProviders;